// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deal-calculator {
  background: radial-gradient(circle at top, #0b1a33, #020617);
  min-height: 100vh;
  padding: 50px;
  color: #fff;
  font-family: "Inter", sans-serif;
}

/* HEADER */
.main-title {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 5px;
}

.main-subtitle {
  color: #94a3b8;
  margin-bottom: 35px;
}

/* TWO COLUMN LAYOUT */
.top-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  margin-bottom: 40px;
}

/* CARD */
.section {
  background: linear-gradient(145deg, #0b1628, #0a1222);
  border-radius: 18px;
  padding: 28px;
  border: 1px solid rgba(255, 215, 0, 0.25);
  box-shadow: 0 0 25px rgba(255, 215, 0, 0.05);
  text-align: left;
}

.section-title {
  font-size: 22px;
  font-weight: 600;
  color: #f8fafc;
  text-align: left;   /* IMPORTANT */
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

.section-subtitle {
  font-size: 14px;
  color: #94a3b8;
  text-align: left;   /* IMPORTANT */
  margin-bottom: 28px;
  line-height: 1.6;
}

/* FORM GRID */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full {
  grid-column: span 2;
}

label {
  font-size: 14px;
  margin-bottom: 6px;
  color: #cbd5e1;
}

/* INPUT STYLE */
input,
select {
  border: 1px solid #334155;
  padding: 12px;
  border-radius: 10px;
  outline: none;
  transition: 0.3s;
}

input:focus,
select:focus {
  border: 1px solid #fbbf24;
  box-shadow: 0 0 10px rgba(251, 191, 36, 0.4);
}

/* SUMMARY CARD */
.summary-card {
  background: linear-gradient(145deg, #111827, #1f2937);
}

/* LIVE RATE GOLD BOX */
.live-rate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(251, 191, 36, 0.15),
    rgba(251, 191, 36, 0.05)
  );
  padding: 14px;
  border-radius: 10px;
  margin-bottom: 25px;
  color: #fbbf24;
  font-weight: 600;
}

/* SUMMARY ROW */
.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* TOTAL */
.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
  font-size: 18px;
}

.total-value {
  font-size: 30px;
  font-weight: 700;
  color: #fbbf24;
}

/* BUTTONS */
.buttons {
  margin-top: 25px;
  display: flex;
  gap: 15px;
}

.btn {
  flex: 1 1;
  padding: 14px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.btn-generate {
  background: linear-gradient(90deg, #fbbf24, #f59e0b);
  border: none;
  color: #000;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(251, 191, 36, 0.4);
}

.btn-whatsapp {
  background: transparent;
  border: 1px solid #334155;
  color: #fff;
}

.btn-whatsapp:hover {
  border: 1px solid #fbbf24;
  color: #fbbf24;
}

/* PAYMENT OPTIONS */
.payment-options {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-top: 15px;
}

.payment-option{
    padding:10px 16px;
    border:1px solid #ccc;
    border-radius:6px;
    cursor:pointer;
}

.payment-option.active{
    /* background:#fbbf24; */
    color:white;
    border-color:#fbbf24;
}input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/pages/DealCalculator/DealCalculator.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB,IAAI,cAAc;EAClC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB,IAAI,cAAc;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;AACvD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;;;GAIC;EACD,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kDAAkD;AACpD;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,oBAAoB;AACxB,CAAC;;EAGC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB","sourcesContent":[".deal-calculator {\n  background: radial-gradient(circle at top, #0b1a33, #020617);\n  min-height: 100vh;\n  padding: 50px;\n  color: #fff;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* HEADER */\n.main-title {\n  font-size: 34px;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.main-subtitle {\n  color: #94a3b8;\n  margin-bottom: 35px;\n}\n\n/* TWO COLUMN LAYOUT */\n.top-sections {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n  margin-bottom: 40px;\n}\n\n/* CARD */\n.section {\n  background: linear-gradient(145deg, #0b1628, #0a1222);\n  border-radius: 18px;\n  padding: 28px;\n  border: 1px solid rgba(255, 215, 0, 0.25);\n  box-shadow: 0 0 25px rgba(255, 215, 0, 0.05);\n  text-align: left;\n}\n\n.section-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #f8fafc;\n  text-align: left;   /* IMPORTANT */\n  margin-bottom: 6px;\n  letter-spacing: 0.3px;\n}\n\n.section-subtitle {\n  font-size: 14px;\n  color: #94a3b8;\n  text-align: left;   /* IMPORTANT */\n  margin-bottom: 28px;\n  line-height: 1.6;\n}\n\n/* FORM GRID */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full {\n  grid-column: span 2;\n}\n\nlabel {\n  font-size: 14px;\n  margin-bottom: 6px;\n  color: #cbd5e1;\n}\n\n/* INPUT STYLE */\ninput,\nselect {\n  border: 1px solid #334155;\n  padding: 12px;\n  border-radius: 10px;\n  outline: none;\n  transition: 0.3s;\n}\n\ninput:focus,\nselect:focus {\n  border: 1px solid #fbbf24;\n  box-shadow: 0 0 10px rgba(251, 191, 36, 0.4);\n}\n\n/* SUMMARY CARD */\n.summary-card {\n  background: linear-gradient(145deg, #111827, #1f2937);\n}\n\n/* LIVE RATE GOLD BOX */\n.live-rate {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(\n    90deg,\n    rgba(251, 191, 36, 0.15),\n    rgba(251, 191, 36, 0.05)\n  );\n  padding: 14px;\n  border-radius: 10px;\n  margin-bottom: 25px;\n  color: #fbbf24;\n  font-weight: 600;\n}\n\n/* SUMMARY ROW */\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n/* TOTAL */\n.total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 25px;\n  font-size: 18px;\n}\n\n.total-value {\n  font-size: 30px;\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n/* BUTTONS */\n.buttons {\n  margin-top: 25px;\n  display: flex;\n  gap: 15px;\n}\n\n.btn {\n  flex: 1;\n  padding: 14px;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.btn-generate {\n  background: linear-gradient(90deg, #fbbf24, #f59e0b);\n  border: none;\n  color: #000;\n}\n\n.btn-generate:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(251, 191, 36, 0.4);\n}\n\n.btn-whatsapp {\n  background: transparent;\n  border: 1px solid #334155;\n  color: #fff;\n}\n\n.btn-whatsapp:hover {\n  border: 1px solid #fbbf24;\n  color: #fbbf24;\n}\n\n/* PAYMENT OPTIONS */\n.payment-options {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n  margin-top: 15px;\n}\n\n.payment-option{\n    padding:10px 16px;\n    border:1px solid #ccc;\n    border-radius:6px;\n    cursor:pointer;\n}\n\n.payment-option.active{\n    /* background:#fbbf24; */\n    color:white;\n    border-color:#fbbf24;\n}input[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
